module.exports = __webpack_public_path__ + "img/ant.783e8a95.png";